'use strict';

function initTileAddToCart() {
    $(document).on('click', '.tile-add-to-cart', function (e) {
        e.preventDefault();

        var $btn = $(this);
        var pid = $btn.data('pid');
        var url = $btn.data('url');

        $btn.prop('disabled', true);
        $.spinner().start();

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                pid: pid,
                quantity: 1,
                options: '[]'
            },
            success: function (data) {
                // Opdater minicart-tæller
                $('.minicart').trigger('count:update', data);

                // Vis "lagt i kurv"-besked (samme som PDP)
                var messageType = data.error ? 'alert-danger' : 'alert-success';

                if ($('.add-to-cart-messages').length === 0) {
                    $('body').append('<div class="add-to-cart-messages"></div>');
                }

                $('.add-to-cart-messages').append(
                    '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
                    + data.message
                    + '</div>'
                );

                setTimeout(function () {
                    $('.add-to-basket-alert').remove();
                }, 5000);

                // Trigger afterAddToCart så andre moduler (fx Klaviyo) også reagerer
                $('body').trigger('product:afterAddToCart', data);
            },
            error: function () {
                $.spinner().stop();
            },
            complete: function () {
                $btn.prop('disabled', false);
                $.spinner().stop();
            }
        });
    });
}

module.exports = {
    initTileAddToCart: initTileAddToCart
};


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/product/tileAddToCart.js